import { useState, useRef, useCallback } from "react";

export default function useVideoNavigation({
  contents,
  loadingMore,
  handleLoadMore,
}) {
  const [activeIndex, setActiveIndex] = useState(0); // Индекс активного элемента

  // Refs для debounce логики
  const scrollTimeoutRef = useRef(null);

  const handleActivateDebounced = useCallback(
    (index) => {
      // Очищаем предыдущий таймаут
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      // Устанавливаем новый таймаут
      scrollTimeoutRef.current = setTimeout(() => {
        setActiveIndex(index);

        // Проверяем нужно ли загрузить больше контента при прокрутке
        if (index >= contents.length - 2 && !loadingMore) {
          handleLoadMore();
        }
      }, 200); // debounce на 100ms
    },
    [contents.length, loadingMore, handleLoadMore]
  );

  // 🔴 Исправление: навигация с поддержкой строк "next"/"previous"
  const handleNavigate = useCallback(
    (direction) => {
      console.log("🔄 handleNavigate called", {
        direction,
        activeIndex,
        contentsLength: contents.length,
      });

      let targetIndex;

      if (direction === "next") {
        targetIndex = activeIndex + 1;
      } else if (direction === "previous") {
        targetIndex = activeIndex - 1;
      } else if (typeof direction === "number") {
        targetIndex = direction;
      } else {
        console.log("❌ Unknown direction type:", direction);
        return; // неизвестный тип направления
      }

      console.log("🎯 Target index:", targetIndex);

      if (targetIndex >= 0 && targetIndex < contents.length) {
        console.log(
          "✅ Valid target index, setting activeIndex to:",
          targetIndex
        );

        // Прокручиваем к целевому элементу используя математический расчет
        if (typeof document !== "undefined") {
          const container = document.querySelector("[data-shorty-feed]");
          console.log("📦 Container found:", !!container);

          if (container) {
            // Рассчитываем высоту элемента математически
            // Это решает проблему с виртуализацией, когда элементы могут не существовать в DOM
            const isMobile = window.innerWidth < 900; // приблизительное определение мобильного устройства
            const elementHeight = isMobile
              ? window.innerHeight
              : window.innerHeight - 64; // высота элемента

            const targetScrollTop = targetIndex * elementHeight;
            const currentScrollTop = container.scrollTop;

            console.log("📏 Scroll calculation:", {
              isMobile,
              windowHeight: window.innerHeight,
              elementHeight,
              targetIndex,
              targetScrollTop,
              currentScrollTop,
              diff: targetScrollTop - currentScrollTop,
            });

            container.scrollTo({
              top: targetScrollTop,
              behavior: "smooth",
            });

            console.log("🚀 Scroll command executed");

            setTimeout(() => {
              container.scrollTo({
                top: targetScrollTop,
                behavior: "smooth",
              });
            }, 100);
          }
        }

        // Проверяем нужно ли загрузить больше контента при навигации через кнопки
        if (targetIndex >= contents.length - 2 && !loadingMore) {
          handleLoadMore();
        }
      } else {
        console.log("❌ Invalid target index:", {
          targetIndex,
          contentsLength: contents.length,
        });
      }
    },
    [activeIndex, contents.length, loadingMore, handleLoadMore]
  );

  // Cleanup при размонтировании
  const cleanup = useCallback(() => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
  }, []);

  return {
    activeIndex,
    handleActivateDebounced,
    handleNavigate,
    cleanup,
  };
}
